import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Endpoints from "../../utils/repository/Endpoints";
import Swal from "sweetalert2";
import Header from "../../utils/components/Header/Header";
import FormInput from "../../utils/components/FormInput/FormInput";
import {
  faKey,
  faUnlock,
  faAt,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const emailFromParams = searchParams.get("email");
  const [email, setEmail] = useState(decodeURIComponent(emailFromParams) || "");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const isValidPassword = () => {
    const isLongEnough = password.length >= 8;
    const hasSpecialCharacters = /[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>]/.test(
      password
    );

    return isLongEnough && hasSpecialCharacters;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !passwordConfirmation) {
      Swal.fire({
        icon: "warning",
        title: "Fehler",
        text: "Beide Passwörter sollten übereinstimmen",
        allowOutsideClick: false,
      });
      setIsSubmitting(false);
      return;
    }

    if (password !== passwordConfirmation) {
      Swal.fire({
        icon: "error",
        title: "Fehler",
        text: "Passwörter stimmen nicht überein!",
        allowOutsideClick: false,
      });
      setIsSubmitting(false);
      return;
    }

    if (!isValidPassword(password)) {
      Swal.fire({
        icon: "warning",
        title: "Ungültiges Passwortformat",
        allowOutsideClick: false,
        html:
          `<ul style="list-style-position: inside; margin-left: 0; text-align: left;">` +
          "Das Passwort muss mindestens 8 Zeichen und ein Sonderzeichen enthalten. Z.B. (&/$/@/%)." +
          `</ul>`,
      });
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    const payload = JSON.stringify({
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    });

    try {
      const response = await fetch(Endpoints.api + Endpoints.resetPassword, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Erfolg",
          timer: 2000,
          text: "Ihr Passwort wurde erfolgreich zurückgesetzt!",
          allowOutsideClick: false,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            navigate("/login");
          },
        });
      } else {
        throw new Error(
          data.message || "Das Zurücksetzen des Passworts ist fehlgeschlagen"
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fehler",
        text: error.message,
        allowOutsideClick: false,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Unautorisierter Zugriff",
        text: "Sie müssen dem Link zum Zurücksetzen des Passworts folgen, der Ihnen per E-Mail zugesandt wurde!",
      }).then(() => {
        navigate("/login");
      });
    }
  }, [navigate, token]);

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <Header />
      <div
        id={"event"}
        style={{
          marginTop: 10,
          padding: 10,
          overflow: "hidden",
          height: "auto",
        }}
      >
        <div
          className="container"
          style={{ maxWidth: "750px", marginTop: "20px" }}
        >
          <h2>Passwort Zurücksetzen</h2>
          <form onSubmit={handleSubmit}>
            <FormInput
              type="email"
              id="email"
              placeholder="Email Address"
              icon={faAt}
              hint=""
              label="Email Address"
              value={email}
              setValue={setEmail}
              disabled={true}
              required
            />
            <FormInput
              type="password"
              id="password"
              placeholder="New Password"
              icon={faKey}
              hint=""
              label="Neues Passwort"
              value={password}
              setValue={setPassword}
              required
            />
            <FormInput
              type="password"
              id="passwordConfirmation"
              placeholder="Confirm Password"
              icon={faUnlock}
              hint=""
              label="Neues Passwort Bestätigen"
              value={passwordConfirmation}
              setValue={setPasswordConfirmation}
              required
            />
            <div
              className="text-muted"
              style={{ fontSize: 12, marginTop: -10 }}
            >
              (Das Passwort muss mindestens 8 Zeichen und ein Sonderzeichen
              enthalten. Z.B. (&/$/@/%).)
            </div>
            {isSubmitting ? (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  height: 50,
                  width: "100%",
                  transition: "0.3s",
                  backgroundColor: "#332885",
                  color: "white",
                  border: "1px solid #332885",
                  borderRadius: 5,
                }}
                id="reset_submitting"
              >
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Wird geladen...</span>
                </div>
              </div>
            ) : (
              <button
                type="submit"
                className=""
                style={{
                  height: 50,
                  width: "100%",
                  transition: "0.3s",
                  backgroundColor: "#332885",
                  color: "white",
                  border: "1px solid #332885",
                  borderRadius: 5,
                  marginTop: 10,
                }}
              >
                Setze dein Passwort zurück <FontAwesomeIcon icon={faRefresh} />
              </button>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
